import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import { useCallback, type ReactNode } from 'react';
import GaTracker from '../../utils/GaTracker/GaTracker';

type Props = {
  open: boolean;
  onClose?: () => void;
  children: ReactNode;
  title?: ReactNode;
  actions?: ReactNode;
  sx?: SxProps<Theme>;
};

export default function Modal({ actions, children, open, onClose, title, sx }: Props) {
  const handleClose = useCallback(() => {
    GaTracker.trackEvent({
      category: 'Modal',
      action: 'close-modal',
    });
    onClose?.();
  }, [onClose]);

  return (
    <Dialog open={open} onClose={onClose} sx={sx} PaperProps={{ 'aria-labelledby': 'modal-title' }}>
      <Box position="absolute" top={4} right={4}>
        {/* TODO: Add Icon */}
        <Button
          color="secondary"
          sx={{
            minWidth: 'unset',
            width: '40px',
            height: '40px',
          }}
          variant="text"
          onClick={handleClose}
        >
          X
        </Button>
      </Box>
      {title && (
        <DialogTitle
          sx={{ mb: 2, borderBottom: (theme) => `1px solid ${theme.palette.grey[200]}` }}
        >
          <Typography variant="h5" component="div" id="modal-title">
            {title}
          </Typography>
        </DialogTitle>
      )}
      <DialogContent>{children}</DialogContent>
      {actions && (
        <DialogActions>
          <Box px="1rem" mb="0.5rem">
            {actions}
          </Box>
        </DialogActions>
      )}
    </Dialog>
  );
}
